import { render, staticRenderFns } from "./add-product-dialog.vue?vue&type=template&id=c392c6d6&scoped=true"
import script from "./add-product-dialog.vue?vue&type=script&lang=js"
export * from "./add-product-dialog.vue?vue&type=script&lang=js"
import style0 from "./add-product-dialog.vue?vue&type=style&index=0&id=c392c6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c392c6d6",
  null
  
)

export default component.exports